export type CustomerTitleDefault = {
  idGender: string;
  idTitle: number;
  market: string | null;
  salutationTranslations: {
    DE?: string;
    FR?: string;
    EN?: string;
    NL?: string;
  };
  sortOrder: number;
  titleCode: string;
  titleNameTranslations: {
    DE?: string;
    FR?: string;
    EN?: string;
    NL?: string;
  };
};

export type CustomerAddress = {
  address?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  city?: string;
  cityFrench?: string;
  country?: string;
  county?: string;
  houseNumber?: string;
  houseNumberAddition?: string;
  idCountry?: number;
  postCode?: string;
};

export type AddressResponse = {
  addresses: Array<CustomerAddress>;
};

export type CustomerDetails = {
  address?: CustomerAddress;
  alternateInvoiceAddress?: boolean;
  companyDepartment?: string;
  companyName?: string;
  dateOfBirth?: string;
  email?: string;
  emailOnly?: boolean;
  exploreMore?: boolean;
  firstName?: string;
  gender?: string;
  idGender?: number;
  idLanguage?: number;
  idTitle?: number;
  invoiceAddress?: CustomerAddress;
  lastName?: string;
  middleName?: string;
  mobilePhoneNumber?: string;
  needInvoice?: boolean;
  phoneNumber?: string;
  subscribeNewsletter?: boolean;
  title?: string;
  vatNumber?: string;
  techAddress?: string | null;
};

export type CustomerNames = {
  idTitle: number;
  firstName: string;
  lastName: string;
  middleName: string;
};
